import { RequiredInput, minLengthValidation } from "."
import { maxLengthValidation } from './index';


export const FormValidation = {
  RequiredInput,
  minLengthValidation,
  maxLengthValidation
}